import { type PropsWithChildren, Component } from 'react';

type Props = {
  onError: (error: Error, info: React.ErrorInfo) => void;
} & PropsWithChildren;
type State = { hasError: boolean };

export class LoadErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.props.onError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
